import { BREAKPOINTS_V3 } from '@jouzen/ecom-components';
import type { ResponsiveType } from 'react-multi-carousel';

export const RESPONSIVE_DATA: ResponsiveType = {
  desktop: {
    breakpoint: {
      max: Infinity,
      min: BREAKPOINTS_V3.large,
    },
    items: 3,
  },
  tablet: {
    breakpoint: {
      max: BREAKPOINTS_V3.large,
      min: BREAKPOINTS_V3.medium,
    },
    items: 2,
  },
  mobile: {
    breakpoint: {
      max: BREAKPOINTS_V3.medium,
      min: 0,
    },
    items: 1,
  },
};
